import { api, LightningElement } from "lwc";

export default class extends LightningElement {
  @api description: string | null = null;
  @api layout: "desktop" | "mobile" = "desktop";
  @api name: string | null = null;
  @api trigger: boolean = false;
}
